module.exports = __webpack_public_path__ + "img/block0Img01.8d1fadbb.png";